import useSWR from 'swr';
import { verifyChainConfig } from '../../../helpers';
import { useWeb3React } from '@web3-react/core';
// import { config } from '../../../config/config';
import { OrderBookType, OrderDataTypes, ResStatus } from '../../../config/constants';
import { Indexed } from 'ethers/lib/utils';
import moment from 'moment';
import { ethers } from 'ethers';
import { OpenPositionParamsStruct } from '../../../config/contracts/typechain/ITradeManager';

const useUserOrders = () => {
    const { chainId, account } = useWeb3React();

    const { data, error, mutate } = useSWR(
        chainId && account ? ['userOrders', chainId, account] : null,
        async (_, chainId, userAddress) => {
            if (!verifyChainConfig(chainId)) return;

            // const res = await fetch(
            //     `${
            //         config.endpoints[chainId].orderBook
            //     }/orders/user/${userAddress.toLowerCase()}`
            // );

            // const orders: ResStatus = await res.json();

            const data: ResStatus['data'] = [
                {
                    createdAt: moment().startOf('day').unix(),
                    id: 'abc',
                    internalId: '123',
                    isMarketOrder: true,
                    isShort: false,
                    liquidationPrice: '3000',
                    maker: ethers.constants.AddressZero,
                    orderJson: JSON.stringify({
                        constraints: {
                            deadline: '1232131',
                            maxPrice: '3300',
                            minPrice: '3100',
                        },
                        params: {
                            isShort: false,
                            leverage: '10',
                            margin: '100',
                            referrer: ethers.constants.AddressZero,
                            tradePair: '0x18394FBCCD11Dfe8a95eC305F57178765bd49aA6',
                            whitelabelAddress:
                                '0x63546ff6d7586a3db4d3676f34106e7583d33c24',
                        },
                        salt: 12312,
                    } as OrderDataTypes<OpenPositionParamsStruct>),
                    orderType: OrderBookType.OPEN,
                    sigHash: '',
                    signature: [],
                    status: 'pending',
                    txHash: '0x00',
                    updatedAt: moment().startOf('day').unix(),
                },
            ];
            return data;
        },
        { dedupingInterval: 0, refreshInterval: 0 }
    );

    const updateUserOrderExecuteStatus = async (signatureHash: Indexed) => {
        await mutate(
            (prevOrders) => {
                if (!prevOrders) return;

                return prevOrders.map((order) =>
                    order.sigHash === signatureHash.hash
                        ? { ...order, status: 'executed' }
                        : order
                );
            },
            { populateCache: true, revalidate: true }
        );
    };

    return {
        userOrders: data,
        isLoading: !data && !error,
        error,
        updateUserOrders: mutate,
        updateUserOrderExecuteStatus,
    };
};

export default useUserOrders;
